import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { BellRing, Loader2, CheckCircle2, Smartphone } from "lucide-react";
import { toast } from "sonner";
import { enablePush, pushSupported, pushEnabled, isIOS, isStandalone } from "@/lib/push";

// Enable web-push notifications for a client or vendor. role: 'client' | 'vendor'
export default function PushToggle({ role }) {
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(pushEnabled());
  const iosNeedsInstall = isIOS() && !isStandalone();

  const activate = async () => {
    setBusy(true);
    try {
      await enablePush(role);
      setDone(true);
      toast.success("Notifiche attivate! Le riceverai anche fuori dall'app.");
    } catch (e) {
      toast.error(e.message || "Impossibile attivare le notifiche");
    } finally { setBusy(false); }
  };

  return (
    <div className="kn-card p-4 space-y-2" data-testid="push-toggle">
      <p className="font-bold text-slate-700 flex items-center gap-2"><BellRing className="h-4 w-4 text-[#E63946]" /> Notifiche sul telefono</p>
      <p className="text-sm text-slate-500">Ricevi un avviso anche quando non hai l'app aperta (conferme spesa, risposte, novità).</p>
      {!pushSupported() ? (
        <p className="text-xs text-slate-400">Questo browser non supporta le notifiche push.</p>
      ) : iosNeedsInstall ? (
        <div className="flex items-start gap-2 rounded-xl bg-amber-50 p-3 text-amber-800 text-sm" data-testid="ios-install-hint">
          <Smartphone className="h-4 w-4 mt-0.5 shrink-0" />
          <span>Su iPhone: tocca <b>Condividi</b> → <b>Aggiungi a Home</b>, poi apri l'app dall'icona e torna qui per attivarle.</span>
        </div>
      ) : done ? (
        <p className="text-sm font-bold text-emerald-600 flex items-center gap-1.5" data-testid="push-active"><CheckCircle2 className="h-4 w-4" /> Notifiche attive</p>
      ) : (
        <Button onClick={activate} disabled={busy} data-testid="push-enable-btn" className="w-full h-11 rounded-xl font-bold gap-2">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <BellRing className="h-4 w-4" />} Attiva notifiche
        </Button>
      )}
    </div>
  );
}
